/** @jsx jsx */
import { jsx } from "theme-ui"
import { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useTranslation } from "react-i18next"
import { Flex } from "rebass"
import { RemoveScroll } from "react-remove-scroll"

import Link from "../../atoms/Link"

import { getResolvedLocale, getDataForLocale } from "../../../utils/i18n"

import hamburger from "../../../images/icons/hamburger.svg"
import closeIcon from "../../../images/icons/close.svg"
import LanguageSwitcher from "../LanguageSwitcher"

const NavItem = ({ children, url, closeMenu, isMenuOpen, index }) => {
  return (
    <Link
      onClick={closeMenu}
      to={url}
      activeClassName="active"
      sx={{
        fontSize: 6,
        my: 3,
        textTransform: "uppercase",
        opacity: isMenuOpen ? 1 : 0,
        transform: isMenuOpen ? "translateY(0)" : "translateY(-10px)",
        transition: isMenuOpen ? "0.5s" : "none",
        transitionDelay: `${(index + 1) * 0.1}s`,
      }}
    >
      {children}
    </Link>
  )
}

const MobileMenu = ({ location }) => {
  const { i18n } = useTranslation()
  const { sanityNavigation } = useStaticQuery(query)
  const [isMenuOpen, setMenuOpen] = useState(false)
  const resolvedLocale = getResolvedLocale(i18n)
  const data = getDataForLocale(sanityNavigation, resolvedLocale.config.code)

  const openMenu = () => {
    setMenuOpen(true)
  }

  const closeMenu = () => {
    setMenuOpen(false)
  }

  return (
    <RemoveScroll enabled={isMenuOpen}>
      <div sx={{ display: ["block", "none"] }}>
        <button
          sx={{
            display: "flex",
            variant: "buttons.reset",
            position: "relative",
            width: "42px",
            height: "42px",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "button",
            borderRadius: "50%",
            backgroundColor: "background",
          }}
          onClick={openMenu}
        >
          <img
            sx={{ width: "20px", height: "6px" }}
            src={hamburger}
            alt="open menu"
          />
        </button>
        <Flex
          sx={{
            overflow: "hidden",
            position: "fixed",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            zIndex: theme => theme.indexes.mobileMenu,
            // backgroundColor: "background",
            p: "20px",
            visibility: isMenuOpen ? "visible" : "hidden",
          }}
        >
          <div
            sx={{
              width: "4px",
              height: "4px",
              backgroundColor: "background",
              borderRadius: "50%",
              position: "absolute",
              top: "44px",
              [`${i18n.dir() === "rtl" ? "left" : "right"}`]: "30px",
              transform: isMenuOpen ? "scale(500)" : "scale(0)",
              transformOrigin: "center",
              transition: isMenuOpen ? "0.5s" : "0.25s",
            }}
          />
          <button
            onClick={closeMenu}
            sx={{
              variant: "buttons.reset",
              position: "absolute",
              top: theme => theme.space[3],
              [`${i18n.dir() === "rtl" ? "left" : "right"}`]: theme =>
                theme.space[3],
              width: "42px",
              height: "42px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 1,
              opacity: isMenuOpen ? 1 : 0,
            }}
          >
            <img src={closeIcon} alt="close menu" />
          </button>
          <Flex
            sx={{
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "-40px",
            }}
          >
            <h3
              sx={{
                fontSize: 0,
                fontWeight: "bold",
                textTransform: "uppercase",
                color: "primary",
                opacity: isMenuOpen ? 1 : 0,
                transform: isMenuOpen ? "translateY(0)" : "translateY(-10px)",
                transition: isMenuOpen ? "0.5s" : "none",
              }}
            >
              Menu
            </h3>
            {data.header.map((navItem, index) => (
              <NavItem
                key={navItem.url}
                url={navItem.url}
                isMenuOpen={isMenuOpen}
                closeMenu={closeMenu}
                index={index}
              >
                {navItem.label}
              </NavItem>
            ))}
          </Flex>
          <div sx={{ opacity: isMenuOpen ? 1 : 0, transition: "0.3s" }}>
            <LanguageSwitcher location={location} isMobile />
          </div>
        </Flex>
      </div>
    </RemoveScroll>
  )
}

export default MobileMenu

const query = graphql`
  query MobileNav {
    sanityNavigation {
      header {
        url
        label {
          ...StringAllLanguages
        }
      }
    }
  }
`
